import { analysisService } from '@libs/data-access/queries'
import { Loader } from '@libs/ui/ds'
import useMemoSelector from '@spa/redux/hooks/useMemoSelector'
import type { FC } from 'react'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchMembership } from 'snap-redux/modules/memberships'
import { getMembershipById } from 'snap-redux/modules/memberships/selectors'
import { fetchShift } from 'snap-redux/modules/shifts'
import { getShiftById } from 'snap-redux/modules/shifts/selectors'
import { getCurrentUserId } from 'snap-redux/modules/users/selectors'
import { fetchWeeklyschedule } from 'snap-redux/modules/weeklyschedules'
import { getWeeklyScheduleById } from 'snap-redux/modules/weeklyschedules/selectors'

import { ShiftRealHoursFormLegacy } from '../../Forms/RealHoursForms/ShiftRealHoursForm/ShiftRealHoursFormLegacy'
import { UnplannedShiftRealHoursFormLegacy } from '../../Forms/RealHoursForms/UnplannedShiftRealHoursForm/UnplannedShiftRealHoursFormLegacy'
import { contractsSelectors } from '../../redux/selectors'

import type { RealHoursContainerProps } from './RealHoursContainer'

/**
 * @deprecated file
 */

export const RealHoursContainerLegacy: FC<RealHoursContainerProps> = ({
  modalData,
  closeModal
}) => {
  const dispatch = useDispatch()
  const userId = useMemoSelector(getCurrentUserId)

  const shift = useMemoSelector(state =>
    getShiftById(state, modalData?.shiftId)
  )

  const weeklyschedule = useMemoSelector(state =>
    getWeeklyScheduleById(state, modalData?.weeklyscheduleId)
  )
  const contracts = contractsSelectors.useGetCachedList()
  const membership = useMemoSelector(state =>
    modalData ? getMembershipById(state, modalData.membershipId) : undefined
  )

  useEffect(() => {
    if (!weeklyschedule) {
      dispatch(fetchWeeklyschedule(modalData.weeklyscheduleId))
    }
    if (!membership) {
      dispatch(fetchMembership(modalData.membershipId))
    }

    /**
     * Force to fetch shift in order to get shift_event data
     */
    dispatch(fetchShift(modalData.shiftId))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isLoading = !shift || !contracts || !membership || !weeklyschedule

  if (isLoading) {
    return <Loader.Overlay />
  }

  const isUnplanned = shift?.planification_type === 'unscheduled'

  return isUnplanned ? (
    <UnplannedShiftRealHoursFormLegacy
      shift={shift}
      formSuccess={() => {
        analysisService.invalidateFetch()
        closeModal()
      }}
      currentUserId={userId}
    />
  ) : (
    <ShiftRealHoursFormLegacy
      shift={shift}
      formSuccess={() => {
        modalData.onSuccess?.()
        analysisService.invalidateFetch()
        closeModal()
      }}
      setDidNotShow={modalData.setDidNotShow}
      currentUserId={userId}
      precomputedCanValidate={modalData.precomputedCanValidate}
    />
  )
}
